import React, {Component, Fragment} from 'react';
import {Row} from 'reactstrap';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import CreateNotificationForm from "../../../../containers/CreateNotificationForm";
import Breadcrumb from '../../../../containers/navs/Breadcrumb';

class Create extends Component {
  render() {
    const {match} = this.props;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <CreateNotificationForm category="DECLARATION"/>
      </Fragment>
    );
  }
}

export default Create;
